import invariant from './invariant';
import getVendorProp from './getVendorProp';

export var FRAME_TIMEOUT = 1000 / 60;

var requestAnimationFrame = getVendorProp(window, 'requestAnimationFrame');
var cancelAnimationFrame = getVendorProp(window, 'cancelAnimationFrame');

/**
 * @returns {Objec.<string, function>}
 */
function createRAF() {
  if (requestAnimationFrame && cancelAnimationFrame) {
    return {
      raf: requestAnimationFrame,
      caf: cancelAnimationFrame
    };
  }

  /**
   * @var {number}
   */
  var last = 0;

  /**
   * @param {function} fn
   * @returns {number}
   */
  function raf(fn) {
    invariant(typeof fn === 'function', 'fn expected a function, instead received %s.', fn);

    var current = Date.now();
    var timeout = Math.max(FRAME_TIMEOUT + (last - current), 0);

    var frameID = setTimeout(function () {
      fn();
      last = Date.now();
    }, timeout);

    return frameID;
  }

  return {
    raf: raf,
    caf: clearTimeout
  };
}

var _createRAF = createRAF(),
    raf = _createRAF.raf,
    caf = _createRAF.caf;

export { raf, caf };


export default createRAF;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/createRAF.js
// module id = 789
// module chunks = 0